export class LandingSite {

    name: string = '';

    code: string = ''; // needed for input to FOS

    gearType: string = ''; // gear type the site belongs to

    licenseAreaNames: string = ''; // area(s) the site belongs to (specified by licenseName, comma-separated if more than one - ex. A, B, D, etc.)

    constructor(name: string = '', code: string = '', gearType: string = '', licenseAreaNames: string = '') {
        this.name = name;
        this.code = code;
        this.gearType = gearType;
        this.licenseAreaNames = licenseAreaNames;
    }

    public toString(): string {

        return this.name;

    }

    public isValid(): boolean {

        return !!this.name;

    }

    public static transformAnonymous(landingSite: any): LandingSite {

        if (!landingSite) { // if the parameter is null
            return new LandingSite(); // return empty landing site
        }

        return new LandingSite (
            landingSite.name ?? '',
            landingSite.code ?? '',
            landingSite.gearType ?? '',
            landingSite.licenseAreaNames ?? ''
        );

    }

}
